import { validation } from '@/util/validation.js';
export default {
  submitText: '变更',
  emptyBtn: false,
  column: [
    {
      label: 'id',
      display: false,
      prop: 'id',
      span: 8,
    },
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      span: 8,
      editDisabled: true,
      disabled: true,
      search: true,
      cell: true,
      props: {
        label: 'title',
        value: 'key',
      },
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
    },
    {
      label: '车牌号',
      disabled: true,
      prop: 'carNo',
      span: 8,
    },
    {
      label: '车辆类型',
      editDisabled: true,
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      prop: 'carType',
      search: true,
      disabled: true,
    },
    {
      label: '租赁起期',
      prop: 'buyStartTime',
      span: 8,
      type: 'date',
      format: 'yyyy-MM-dd 00:00:00',
      valueFormat: 'yyyy-MM-dd 00:00:00',
      editDisabled: true,
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入租赁止期',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收费套餐',
      prop: 'ruleName',
      span: 8,
      disabled: true,
    },

    {
      label: '租赁止期',
      prop: 'buyEndTime',
      type: 'date',
      format: 'yyyy-MM-dd 23:59:59',
      valueFormat: 'yyyy-MM-dd hh:mm:ss',
      span: 8,
      disabled: true,
      rules: [
        {
          required: true,
          message: '请输入租赁止期',
          trigger: 'change',
        },
      ],
    },
    {
      label: '应收金额',
      prop: 'shouldMoney',
      span: 8,
      disabled: true,
      rules: [
        {
          required: false,
          message: '请输入应收金额',
          trigger: 'change',
        },
      ],
    },
    {
      label: '客户姓名',
      span: 8,
      search: true,
      prop: 'customerName',
      disabled: true,
      rules: [
        {
          message: '请输入客户姓名',
          trigger: 'change',
        },
      ],
    },
    {
      label: '客户手机',
      prop: 'customerPhone',
      disabled: true,
      span: 8,
      search: true,
      /* rules: [
        {
          message: '请输入客户手机号',
          trigger: 'change',
        },
      ],*/
    },

    {
      label: '状态',
      prop: 'status',
      display: false,
    },
    {
      label: '操作',
      prop: 'operateType',
      display: false,
    },
    {
      label: '车位编号',
      prop: 'lotNo',
      hide: true,
      span: 8,
      rules: [
        {
          required: false,
          message: '请输入停车车位编号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '房产信息',
      prop: 'areaName',
      hide: true,
      disabled: true,
      span: 16,
      rules: [
        {
          required: false,
          message: '请输入房产信息',
          trigger: 'change',
        },
      ],
    },
    {
      label: '新车牌号',
      hide: true,
      prop: 'newCarNo',
      span: 8,
      rules: [
      {
        required: true,
        message: '请输入新车牌号',
        trigger: 'change',
      },
        {
          required: true,
          message: '车牌号格式错误',
          pattern: validation.carPlate,
          trigger: 'change',
        },
        /*{
          pattern: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1})$/,
          message: '车牌号格式错误',
          trigger: 'blur',
        },*/
      ],
    },
    {
      label: '说明',
      prop: 'remark1',
      hide: true,
      span: 16,
      rules: [
        {
          required: false,
          message: '请输入备注1',
          trigger: 'change',
        },
      ],
    },
  ],
};
